import './IntegrationsContainer.scss';

import { FC, useContext, useEffect } from 'react';
import { AppContext } from 'components/AppContext/AppContext';
import SocialSetup from 'modules/Social/SocialSetup/SocialSetup';
import { Col, Nav, Row } from 'react-bootstrap';
import Tab from 'react-bootstrap/Tab';

import WebhooksList from '../WebhooksList/WebhooksList';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IntegrationsContainerProps { }

const IntegrationsContainer: FC<IntegrationsContainerProps> = () => {
  const { setIsProjectSelectable } = useContext(AppContext);

  useEffect(() => {
    setIsProjectSelectable(true);
  }, []);

  return (
    <div className="IntegrationsContainer">
      <Tab.Container id="integration-tabs" defaultActiveKey="social">
        <Row className="fit-to-screen">
          <Col sm={2} className='sidebar pt-2'>
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="social" className='sidebar-action integration-tab'>
                  <i className='bi bi-share-fill' />
                  <span className='route-name'>Social Media</span>
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="webhooks" className='sidebar-action integration-tab'>
                  <i className='bi bi-stack' />
                  <span className='route-name'>Webhooks</span>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={10} className='pt-3 ps-3 pb-5'>
            <Tab.Content>
              <Tab.Pane eventKey="social">
                <SocialSetup />
              </Tab.Pane>
              <Tab.Pane eventKey="webhooks">
                <WebhooksList />
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>

    </div>
  )
};

export default IntegrationsContainer;
